import React, { useState, useEffect } from 'react';
import { Card, CardBody, CardHeader, Col, Container, Row } from 'reactstrap';
import Breadcrumbs from '../../CommonElements/Breadcrumbs';
import { H5 } from '../../AbstractElements';
import Chart from 'react-apexcharts';
import { apiPost } from '../../Utils';

const Reports = () => {
    const [chartData, setChartData] = useState<any>(null);
    const [stats, setStats] = useState<any>(null);

    useEffect(() => {
        // Fetch Stats
        apiPost("reports/stats", {}).then((res: any) => {
            if (res) {
                setStats(res.counts);
                if (res.chart) {
                    setChartData({
                        series: [{
                            name: 'Monthly Expenses',
                            data: res.chart.expenses
                        }],
                        options: {
                            chart: { type: 'bar' as const, height: 350 },
                            plotOptions: {
                                bar: { horizontal: false, columnWidth: '55%', endingShape: 'rounded' },
                            },
                            dataLabels: { enabled: false },
                            stroke: { show: true, width: 2, colors: ['transparent'] },
                            xaxis: {
                                categories: res.chart.months,
                            },
                            fill: { opacity: 1 },
                            colors: ['#7366ff'],
                            tooltip: {
                                y: { formatter: function (val: number) { return "AED " + val } }
                            }
                        }
                    });
                }
            }
        });
    }, []);

    return (
        <div className="page-body">
            <Breadcrumbs parent="Analytics" title="Reports" pageTitle="Fleet Overview" />
            <Container fluid>
                <Row>
                    <Col md={12} className="mb-4">
                        <div className="d-flex justify-content-between">
                            <Card className="flex-fill me-2 text-center p-3">
                                <h6>Total Vehicles</h6>
                                <h3>{stats?.total_vehicles || 0}</h3>
                            </Card>
                            <Card className="flex-fill me-2 text-center p-3">
                                <h6>Active Vehicles</h6>
                                <h3 className="text-success">{stats?.active_vehicles || 0}</h3>
                            </Card>
                            <Card className="flex-fill me-2 text-center p-3">
                                <h6>In Maintenance</h6>
                                <h3 className="text-warning">{stats?.maintenance_vehicles || 0}</h3>
                            </Card>
                            <Card className="flex-fill text-center p-3">
                                <h6>Total Drivers</h6>
                                <h3>{stats?.total_drivers || 0}</h3>
                            </Card>
                        </div>
                    </Col>

                    <Col xl={12} md={12}>
                        <Card>
                            <CardHeader>
                                <H5>Monthly Expenses Overview (Last 6 Months)</H5>
                            </CardHeader>
                            <CardBody>
                                {chartData && <Chart options={chartData.options} series={chartData.series} type="bar" height={350} />}
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </Container>
        </div>
    );
};

export default Reports;
